// ---------------------------------------------------------------------------
// Identidade visual da loja de fichas (vitrine, carteira, Pix da loja).
// Um só lugar para o azul-marinho, o dourado e as bordas claras — assim as
// três telas não saem do tom uma da outra.
// Nada aqui toca no banco: são só cores e medidas.
// ---------------------------------------------------------------------------

/** Fundo das telas de ficha/carteira. */
export const NAVY = '#10203A';
/** Rodapé fixo (um tom abaixo do fundo). */
export const NAVY_PE = '#0B1729';
/** Dourado dos valores, números e do botão principal. */
export const OURO = '#E8C877';
/** Dourado um pouco mais fechado (contorno de botão). */
export const OURO_CONTORNO = 'rgba(232,200,119,0.55)';
/** Borda clara dos cartões escuros. */
export const BORDA_CLARA = 'rgba(255,255,255,0.10)';
/** Fundo dos cartões escuros. */
export const CARTAO = 'rgba(255,255,255,0.05)';

/** Raio padrão da identidade (16 px). */
export const RAIO = 16;